<style lang="scss" scoped>
  @import "../../../../assets/scss/mixins";

  $leftWidth: 220px;

  .el-form .el-checkbox__label {
    font-size: 12px;
    padding-left: 5px;
  }

  .el-form .el-checkbox__inner {
    width: 14px;
    height: 14px;
  }

  .content-part {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;

    .content-left {
      width: $leftWidth;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      text-align: left;
      background-color: #eef2f3;

      > ul {
        margin: 0;
      }

      > h2 {
        padding: 0;
        margin: 0;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        border-bottom: 1px solid #ddd;
        background-color: #eef2f3;
      }

      .list-style {
        cursor: pointer;
        padding: 10px;
        text-align: center;

        span {
          display: inline-block;
          padding: 8px 35px;
        }

        &.active {
          span {
            background-color: $activeColor;
            border-radius: 20px;
            color: $activeColorFont
          }
        }

        &:hover {
          background: #dee9eb
        }

      }

    }

    .content-right {
      > h3 {
        padding: 0;
        margin: 0 0 20px;
        font-size: 18px;
        font-weight: normal;
        line-height: 55px;
        height: 55px;
        border-bottom: 1px solid #ddd;
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        left: $leftWidth;
        background: #fff;
        z-index: 2;
      }

      position: absolute;
      top: 0;
      left: $leftWidth;
      right: 0;
      bottom: 0;
      overflow: auto;
      /*.hide-content {*/
      /*display: none;*/
      /*}*/
      /*.show-content {*/
      /*display: block;*/
      /*}*/
    }

    .btn-submit-save {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      text-align: center;
      padding: 15px;
    }

    .min-gutter {
      .el-form-item {
        /*margin-bottom: 20px;*/
      }

      .el-form-item__label {
        font-size: 12px
      }
    }

    .qp-box {
      margin-bottom: 5px;
      padding: 4px;
      box-shadow: 0 2px 1px 0 #ddd;
    }
  }

  .el-form .el-select {
    display: block;
  }

  .el-form .el-date-editor {
    display: block;
  }

  .el-form {
    position: relative;

    &.active {
      border-color: $activeColor;

      .title-link {
        color: $activeColor;
      }
    }
  }

  .title-link {
    position: absolute;
    top: -10px;
    left: 5px;
    padding: 0;
  }

</style>
<template>
  <div>
    <div class="content-right min-gutter">
      <h3>编辑货主编码</h3>
      <div>
        <el-form ref="goodSForm" :model="form" label-width="120px" :rules="rules"
                 @submit.prevent="onSubmit('goodSForm')" onsubmit="return false" style="padding-right: 20px">
          <el-form-item label="货主编码" label-width="120px" prop="ownerCode">
            <el-input placeholder="请输入货主编码" v-model="form.ownerCode"></el-input>
          </el-form-item>
          <el-form-item label-width="100px">
            <el-button type="primary" @click="onSubmit('goodSForm')" native-type="submit" :disabled="doing">保存
            </el-button>
            <el-button @click="doClose">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script type="text/jsx">

  export default {
    data: function () {
      let checkOwnerCode = (rule, value, callback) => {
          if (value&&value.indexOf(' ')!==-1) {
            callback(new Error('货主编码不能包含空格'));
          } else {
            callback();
          }
      };
      return {
        form: {
          ownerCode: ''
        },
        goodsList: [], // oms货品列表
        doing: false,
        customerList: [],
        loading: false,
        rules: {
          ownerCode: [
            {validator: checkOwnerCode, trigger: 'blur'}
          ],
        }
      };
    },
    props: ['formItem'],
    mounted: function () {
    },
    computed: {},
    watch: {
      formItem: function (val) {
        if (!val.id) return;
        this.form = Object.assign({}, val);
      }
    },
    methods: {
      onSubmit: function (formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid || this.doing) return;
          this.doing = true;
          this.$http.put('dhs-operation-goods', {
            id: this.form.id,
            ownerCode: this.form.ownerCode
          }).then(() => {
            this.doing = false;
            this.$notify.success({
              duration: 2000,
              name: '成功',
              message: '编辑成功'
            });
            this.$emit('change', this.form);
            this.$emit('right-close', this.form);
          }).catch(error => {
            this.$notify.error({
              duration: 2000,
              message: error.response.data && error.response.data.msg || '编辑失败'
            });
            this.doing = false;
          });
        });
      },
      doClose: function () {
        this.$emit('right-close');
        this.$refs['goodSForm'].resetFields();
      }
    }
  };
</script>
